import React from "react";
import CaroselloStandard from "../commons/CaroselloStandard";
import foto1 from "../images/Palestra/IMG_9287.jpg"
import foto2 from "../images/Palestra/IMG_9288.jpg"
import foto3 from "../images/Palestra/IMG_9289.jpg"
import foto4 from "../images/Palestra/IMG_1287.jpg"
import copertina from "../images/Palestra/foto1.jpg"
import Titolo from "../commons/Titolo";
import PalestraAccordion from "../components/palestra/Vecchi/PalestraAccordion";
import ScrollToTopOnMount from "../components/ScrollToTopOnMount";
import Space from "../commons/Space";
import CardMultitessere from "../components/CardMultitessere";
import TitoloSezioni from "../commons/TitoloSezioni";
import CardInEvidenza from "../components/CardInEvidenza";
import promo from "../images/News/Promo_fine_stagione.png";
import CardNewsEvidenza from "../components/CardNewsEvidenza";
import barista from "../images/News/Barista.png";
import SpaceL from "../commons/SpaceL";
import PalAccordionPrezzi from "../components/palestra/PalAccordionPrezzi";
import Spa from "./Spa";
import {Helmet} from "react-helmet";
import CardNewsEvidenzaFoto from "../components/CardNewsEvidenzaFoto";
import facilitazione from "../images/Evidenza/Card_facilitazione.png";
import CardNews from "../components/CardNews";
import CardInEvidenzaFoto from "../components/CardInEvidenzaFoto";
import pt from "../images/Palestra/Pt.png";


function Palestra() {
    return(
        <div>
            <Helmet>
                <title>Palestra</title>
                <meta name="description" content="Accesso libero ai due ambienti: sala cardio e sala pesi. Scheda personalizzata per tutti gli iscritti" />
            </Helmet>
            <ScrollToTopOnMount />
            <Titolo backgroundImage={copertina} title={"Palestra"}/>
            <SpaceL />
            <div style={{padding: "1em"}}>
                <figure className="text-center">
                    <blockquote className="blockquote">
                        <h3>Sala cardio e sala pesi</h3>
                        <div>Accesso libero ai due ambienti</div>
                        <br/>
                        <div><strong>Scheda personalizzata</strong> per tutti gli iscritti
                        <br/>
                            <br/>
                            Personale di sala sempre presente</div>
                        <p>

                            <br/>
                        </p>
                    </blockquote>
                </figure>
                <br/>
                <table className="table  m-auto" style={{width: "20em"}}>
                    <colgroup>
                        <col style={{ minWidth: "40px"}} />
                        <col style={{ minWidth: "40px" }} />

                    </colgroup>

                    <tbody>
                    <tr>
                        <th className="data-cell">Lunedì</th>
                        <td className="data-cell">7-22</td>
                    </tr>
                    <tr>
                        <th className="data-cell">Martedì</th>
                        <td className="data-cell">9-22</td>
                    </tr>
                    <tr>
                        <th className="data-cell">Mercoledì</th>
                        <td className="data-cell">7-22</td>
                    </tr>
                    <tr>
                        <th className="data-cell">Giovedì</th>
                        <td className="data-cell">9-22</td>
                    </tr>
                    <tr>
                        <th className="data-cell">Venerdì</th>
                        <td className="data-cell">7-22</td>
                    </tr>
                    <tr>
                        <th className="data-cell">Sabato</th>
                        <td className="data-cell">9-19</td>
                    </tr>
                    <tr>
                        <th className="data-cell">Domenica</th>
                        <td className="data-cell">9-13</td>
                    </tr>
                    </tbody>
                </table>
            <Space />

                <PalAccordionPrezzi />
                {/*<SpaceL/>*/}
                
                {/*<figure className="text-center">*/}
                {/*    <blockquote className="blockquote">*/}
                {/*        <p>*/}
                {/*            <span className="fw-bold" style={{fontSize: "18px"}}>Allenamento al femminile</span><br className="d-block d-sm-none"/> con Loredana*/}
                {/*            <span style={{fontSize: "16px"}}>*/}
                {/*        <hr className="m-auto" style={{maxWidth: "18em"}}/>*/}
                {/*        Lezioni individuali a corpo libero per migliorare mobilità articolare, flessibilità, forza e resistenza*/}
                {/*        <br/>Pacchetto 10 lezioni da 50 minuti: 300€*/}
                {/*        <br/>Pacchetto 10 lezioni di coppia da 50 minuti: 400€*/}
                {/*        <br/> Per una prova gratuita scrivi a <span/>*/}
                {/*       <a style={{color: "grey"}} title="mailto:loredanatraining@gmail.com" href="mailto:loredanatraining@gmail.com">loredanatraining@gmail.com</a>*/}
                {/*        </span>*/}
                
                {/*        </p>*/}
                {/*    </blockquote>*/}
                {/*</figure>*/}
                <SpaceL />
                <div className="d-flex flex-column text-center align-items-center justify-content-center">
                    <CardInEvidenzaFoto foto={pt} width={"90%"} posizioneFoto={"center"} indirizzo={"/news/personaltraining"} />
                </div>
                <SpaceL />
                <CaroselloStandard foto1={foto1} foto2={foto2} foto3={foto3} foto4={foto4}/>
            <Space />
            <div className="d-flex flex-column text-center align-items-center justify-content-center">
                <TitoloSezioni title={"Multitessere"} />
                <h4 style={{fontFamily: "Hammersmith One"}}>Scopri le nostre multitessere</h4>
                <CardMultitessere />
            </div>
                <Space />

            <Space />
            </div>
        </div>
    )
}


export default Palestra
